import { render, staticRenderFns } from "./DuplicateViewModal.vue?vue&type=template&id=321858b2"
import script from "./DuplicateViewModal.vue?vue&type=script&lang=ts"
export * from "./DuplicateViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321858b2')) {
      api.createRecord('321858b2', component.options)
    } else {
      api.reload('321858b2', component.options)
    }
    module.hot.accept("./DuplicateViewModal.vue?vue&type=template&id=321858b2", function () {
      api.rerender('321858b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/DuplicateViewModal.vue"
export default component.exports